import { HStack, Modal, ScrollView, Text } from 'native-base';
import { OrderRow } from './OrderRow';
import React, { useState } from 'react';
import { Fulfillment } from '../../../__generated__/graphql';
import { OrderModal } from '../Order Modal/OrderModal';

export const OrdersTable = ({ orders, loading }: { orders: Fulfillment[]; loading: boolean }) => {
  const [openOrder, setOpenOrder] = useState<Fulfillment | undefined>();

  return (
    <>
      <HStack bg="gray.100">
        <Text fontWeight={600} p={4} flex={1}>
          Ordered
        </Text>

        <Text fontWeight={600} p={4} flex={1}>
          Order Age
        </Text>

        <Text fontWeight={600} p={4} flex={1}>
          Status
        </Text>

        <Text fontWeight={600} p={4} flex={1}>
          Customer
        </Text>

        <Text fontWeight={600} p={4} flex={2}>
          Products
        </Text>

        <Text fontWeight={600} p={4} flex={1}>
          Shipping Method
        </Text>
      </HStack>

      {!loading && orders?.length === 0 && (
        <Text color={'gray.400'} flex={1} textAlign={'center'} p={8}>
          No orders
        </Text>
      )}

      <ScrollView flex={1}>
        {orders?.map((order) => {
          return <OrderRow key={order?.id} order={order} onPress={() => setOpenOrder(order)} />;
        })}
      </ScrollView>

      <Modal isOpen={!!openOrder} h={'100vh'} size={'full'} onClose={() => setOpenOrder(undefined)}>
        {openOrder && (
          <OrderModal
            closeModal={() => setOpenOrder(undefined)}
            customerId={openOrder?.customer?.id ?? ''}
            orderID={openOrder.id ?? ''}
          />
        )}
      </Modal>
    </>
  );
};
